/**
 * Application configuration
 * Handles environment-specific settings
 */

// Get the base URL for API calls
const getApiBaseUrl = (): string => {
    // Use environment variable (set in .env.production or .env.development)
    return import.meta.env.VITE_API_URL || 'http://localhost:8000';
};

// Get the WebSocket URL
const getWebSocketUrl = (): string => {
    const apiUrl = getApiBaseUrl();

    // Convert http/https to ws/wss
    return apiUrl.replace(/^http/, 'ws');
};

export const config = {
    apiBaseUrl: getApiBaseUrl(),
    wsBaseUrl: getWebSocketUrl(),

    // API endpoints
    api: {
        auth: '/api/v1/auth',
        users: '/api/v1/users',
        matches: '/api/v1/matches',
        scenarios: '/api/v1/scenarios',
        sessions: '/api/v1/sessions',
        messages: '/api/v1/messages',
        notifications: '/api/v1/notifications',
    },

    // WebSocket endpoints
    ws: {
        session: (sessionId: string, token: string) =>
            `${getWebSocketUrl()}/ws/session/${sessionId}?token=${encodeURIComponent(token)}`,
        notifications: (token: string) =>
            `${getWebSocketUrl()}/ws/notifications?token=${encodeURIComponent(token)}`,
    },
};

export default config;
